@if (pageData && pageData.benchmarks.length) {
  <app-benchmark-detail
    [benchmarkListInput]="pageData.benchmarks"
    (selectedBenchmarkChange)="onSelectedBenchmarksChange($event)"
  ></app-benchmark-detail>
}


@if (pageData && pageData.periods.length) {
  <app-period-detail
    [periodListInput]="pageData.periods"
    (selectedPeriodChange)="onSelectedPeriodsChange($event)"
  ></app-period-detail>
}

@if (pageData) {
  <app-section-list
    [pageId]="pageData.id"
    [selectedBenchmark]="selectedBenchmarks"
    [selectedPeriod]="selectedperiods"
  ></app-section-list>
}

@if (pageData?.is_downloadable) {
  <app-cards-basic title="Downloads">
    <app-report-list-public [productId]="pageData.product.id"></app-report-list-public>
  </app-cards-basic>

}

<app-subscribtions [productId]="pageData?.product.id"></app-subscribtions>
